import { createEndpoint } from "config/apiEndpoints";
import { commonData } from "data/CommonDataPoint";
import { FetchData } from "hooks/api/useApiService";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { generalStore } from "store/generalStore";
import { getUserType } from "store/userType";
import { getFromStorage } from "utils/storage";
import useProfileApi from "../Profile/useProfileApi";
import useToasterStore from "store/SnackBar/useToasterStore";

const useHeader = () => {
  const [projectMenu, setProjectMenu] = useState(false);
  const isUserType = getUserType((state) => state.isUserType);
  const setUserType = getUserType((state) => state.setUserType);
  const setSelectedProject = generalStore((state) => state.setSelectedProject);
  const selectedProject = generalStore((state) => state.selectedProject);
  const setProjectListData = generalStore((state) => state.setProjectListData);
  const projectListData = generalStore((state) => state.projectListData);
  const openToaster = useToasterStore((state) => state.openToaster);

  const [counts, setCounts] = useState({
    userCount: 0,
    ebwCount: 0,
    customerProjectCount: 0,
  });

  const countTypes = [
    // { key: "userCount", message: "users created till date" },
    { key: "activeUsers", message: " Active users  till date" },
    { key: "ebwCount", message: "EBWs created till date" },
    // { key: "customerCount", message: "customers created till date" },
  ];

  let countIndex = 0;

  const { mutateLogOut } = useProfileApi();

  const checkAccessAction = {
    select: (data) => {
      const list = data.data;
      return list;
    },
    onSuccess: (data) => {
      if (data?.statusCode == 200) {
        if (data?.data?.userRole?.length > 1) {
          const role = isUserType || getFromStorage("user_data")?.user_role;

          if (
            data?.data?.userRole?.filter((roles) => roles == role)?.length > 0
          ) {
            setUserType(
              data?.data?.userRole?.filter((roles) => roles == role)[0]
            );
          } else {
            mutateLogOut();
          }
        } else {
          setUserType(data?.data?.userRole[0]);
        }
        // if()
        // if(location?.pathname?.split("/")[1] !==data?.data?.userRole){
        //   // history.replace("")
        //   history.goBack()

        // }
        // setSelectedProject(data?.data[0]?.projectId);
      }
    },
    retry: false,
    // enabled: false,
  };
  const { refetch: fetchCheckAccess } = FetchData(
    "checkAccess",
    createEndpoint("checkAccess"),
    checkAccessAction
  );

  const projectListingAction = {
    select: (data) => {
      const list = data.data;
      return list;
    },
    onSuccess: (data) => {
      if (data?.statusCode == 200) {
        setProjectListData(data?.data);
        if (selectedProject == null && commonData?.admin == "admin") {
          setSelectedProject(data?.data[0]?.projectId);
        }
      }
    },
    retry: false,
    enabled:
      isUserType !== "Customer" && projectListData?.length == 0 ? true : false,
  };
  const { refetch } = FetchData(
    "userProjectList",
    createEndpoint("userProjectList"),
    projectListingAction
  );

  const getCountsAction = {
    select: (data) => {
      const list = data.data;
      return list;
    },
    onSuccess: (data) => {
      if (data?.statusCode == 200) {
        setCounts(data.data);
      }
    },
    retry: false,
    enabled: false,
  };
  const { refetch: fetchCounts } = FetchData(
    "fetchCounts",
    createEndpoint("getAllCounts", `?projectId=${selectedProject}`),
    getCountsAction
  );

  const handleSelectChange = (event) => {
    setSelectedProject(event.target.value);
  };
  const handleSelectMobileChange = (id) => {
    setSelectedProject(id);
    handleProjectMenu();
  };
  const handleProjectMenu = () => {
    if (!projectMenu) {
      setProjectMenu(true);
      document.body.classList.add("cm-overflow-hidden");
    } else {
      setProjectMenu(false);
      document.body.classList.remove("cm-overflow-hidden");
    }
  };

  useEffect(() => {
    if (isUserType == "admin" && selectedProject !== null) {
      // Fetch data initially
      fetchCounts();

      // Set interval to fetch data every 5 seconds
      const intervalId = setInterval(() => {
        fetchCounts();

        // Merge userCount & customerCount
        const activeUsers = counts.userCount + counts.customerProjectCount;

        const notifications = {
          activeUsers,
          ebwCount: counts.ebwCount,
        };

        const currentType = countTypes[countIndex];
        // openToaster(
        //   "info",
        //   `${counts[currentType.key]} ${currentType.message}`
        // );
        openToaster(
          "info",
          `${notifications[currentType.key]} ${currentType.message}`
        );

        countIndex = (countIndex + 1) % countTypes.length; // Cycle through count types
      }, 600000);

      // Clear interval on component unmount
      return () => clearInterval(intervalId);
    }
  }, [counts]);

  // useEffect(() => {
  //   if (isUserType == null) {
  //     fetchCheckAccess()
  //   }
  // }, [isUserType]);

  return {
    projectListData,
    projectMenu,
    selectedProject,
    handleSelectChange,
    handleProjectMenu,
    setProjectMenu,
    handleSelectMobileChange,
  };
};

export default useHeader;
